import React, { useEffect, useState } from "react"
import { handleColor } from "./helpers/handleColors"
import { TrainWrapper, TrainComponent, TrainElement } from "./TrainStyles"

interface Train_Props {
  round: any
  history: string[]
}
export default function Train({ round, history }: Train_Props) {
  const [anim, setanim] = useState<boolean>(false)
  const [firstAnim, setfirstAnim] = useState<boolean>(false)
  const [trainInfo, setTrainInfo] = useState<any>([])
  useEffect(() => {
    if (history) {
      history.length > 6
        ? setTrainInfo(history.slice(0, 6).reverse())
        : setTrainInfo(history.reverse()) //temp
    }
  }, [history])

  useEffect(() => {
    if (round.state === 3) {
      if (round.value !== "") {
        setfirstAnim(true)
        setanim(true)
        setTrainInfo((ti: any) => [...ti, round.value])
        setTimeout(() => {
          setTrainInfo((ti: any) => {
            ti.shift()
            return ti
          })
          // setTrainInfo((ti: any) => ti.slice(1, ti.length))
          // setTimeout(() => {
          setanim(false)
          setfirstAnim(false)
          // }, 100)
        }, 500)
      }
    }
  }, [round])
  return (
    <>
      <TrainWrapper>
        {trainInfo &&
          trainInfo.map((t: any, id: number) => (
            <TrainComponent key={id} anim={anim} id={id} firstAnim={firstAnim}>
              <TrainElement color={handleColor(t)}>
                {t > 999 ? Number(t).toFixed(0) : t}x
              </TrainElement>
            </TrainComponent>
          ))}
      </TrainWrapper>
    </>
  )
}
